// extracted by mini-css-extract-plugin
export default {"page":"home_page__znvhD","category-tab":"home_category-tab__S2-uR"};